/**
 * @generated SignedSource<<5626d1a7dfbd68c0ede9e99ba4bebf4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutAuthActions_userExistsMetadata$data = {
  readonly emailOnly: boolean | null;
  readonly hasApple: boolean | null;
  readonly hasFacebook: boolean | null;
  readonly hasGoogle: boolean | null;
  readonly hasPassword: boolean | null;
  readonly " $fragmentType": "checkoutAuthActions_userExistsMetadata";
};
export type checkoutAuthActions_userExistsMetadata$key = {
  readonly " $data"?: checkoutAuthActions_userExistsMetadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutAuthActions_userExistsMetadata">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutAuthActions_userExistsMetadata"
};

(node as any).hash = "65e68c3b7fe05dee4cd8cd9fcf0b632c";

export default node;
